<template lang="pug">
  .page.page_brands
    header.page__header
      h2.page__title
        transition(name="transition-title" appear)
          span {{ $t('brands.title') }}
      span.page__close
        transition(name="transition-title" appear)
          span(@click="$router.push({path: '/'})") {{ $t('brands.close') }}
    ul(class="page__brands-list")
      li.page__brand(v-for="(brand, index) in content.brands" :key="index")
        transition(name="transition" appear)
          .page__brand-wrap-img
            img.page__brand-img(:src="brand.image" :alt="brand.name")
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Brands',
  computed: {
    ...mapGetters({
      content: 'home/getContent'
    })
  },
  created () {
    document.body.style.overflow = 'hidden'
  },
  destroyed () {
    document.body.removeAttribute('style')
  }
}
</script>

<style scoped>
  .transition-enter-active {
    transition: all .3s ease-out;
    transition-delay: .4s;
  }
  .transition-leave-active {
    transition: all .3s ease-out;
    transition-delay: 1s;
  }
  .transition-enter, .transition-title-enter {
    transform: translateY(100%);
  }
  .transition-leave-to, .transition-title-leave-to {
    transform: translateY(100%);
  }

  .transition-title-enter-active {
    transition: all .3s ease-out;
    transition-delay: .3s;
  }

</style>



// WEBPACK FOOTER //
// src/components/Brands.vue